import { render, staticRenderFns } from "./AbstractCookiesPage.vue?vue&type=template&id=40776c24"
import script from "./AbstractCookiesPage.vue?vue&type=script&lang=js"
export * from "./AbstractCookiesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports